// src/components/auth/RegisterMultiStepForm.jsx
import Button from "../ui/buttons/Button";
import RegisterMultiStepStyle from "../../style/components/auth/RegisterMultiStepForm.module.css";
import Loader from "../ui/Loader/Loader";
import { useRegister } from "../../hooks/useAuth";

export const RegisterMultiStepForm = ({
  steps,
  onSubmit,
  onSendOTP,
  onVerifyOTP,
}) => {
  const {
    currentStep,
    formData,
    stepErrors,
    setStepErrors,
    isSubmitting,
    handleChange,
    nextStep,
    prevStep,
    resendCooldown, // Destructured
    handleResendOTP, //
    isResending,
    canResend, // Destructured
    submit,
  } = useRegister({ steps, onSubmit, onSendOTP, onVerifyOTP });

  const CurrentStep = steps[currentStep].component;

  return (
    <div>
      <CurrentStep
        formData={formData}
        onChange={handleChange}
        errors={stepErrors}
        setStepErrors={setStepErrors}
        resendCooldown={resendCooldown}
        handleResendOTP={handleResendOTP}
        canResend={canResend}
        isResending={isResending}
      />

      <div className={RegisterMultiStepStyle.RegisterMultiStepFormButton}>
        {currentStep > 0 && currentStep < steps.length - 1 && (
          <Button
            type="button"
            variant="outline"
            onClick={prevStep}
            disabled={isSubmitting}
          >
            Back
          </Button>
        )}
        {currentStep < steps.length - 1 ? (
          <Button onClick={nextStep} disabled={isSubmitting}>
            {isSubmitting ? <Loader /> : "Continue"}
          </Button>
        ) : (
          <Button onClick={submit} disabled={isSubmitting}>
            {isSubmitting ? <Loader /> : "Submit"}
          </Button>
        )}
      </div>
    </div>
  );
};
